export default __webpack_public_path__ + "static/media/featureFlower3x.fa2f3a24.png";